import { z } from 'zod';
/**
 * Sprint có trí nhớ — APM-AGILE-c.
 *
 * Agile không phải là "chia việc thành từng đợt hai tuần". Nó là vòng lặp **kiểm
 * tra và thích nghi**. Bỏ phần thích nghi thì còn lại waterfall bị băm nhỏ — và
 * trước task này, sprint đóng xong thì thứ duy nhất còn lại là một con số
 * velocity.
 */
export const SprintGoalOutcome = z.enum(['met', 'partial', 'missed']);
/**
 * `try_it` chứ không `try`: `try` là từ khoá của nhiều SQL dialect, và một giá
 * trị enum phải quote ở mọi câu truy vấn là một cái bẫy chờ sẵn.
 */
export const RetroItemKind = z.enum(['keep', 'drop', 'try_it']);
export const RetroItemStatus = z.enum(['open', 'done', 'dropped']);
export const RetroItemView = z.object({
    id: z.uuid(),
    sprintId: z.uuid(),
    kind: RetroItemKind,
    content: z.string(),
    status: RetroItemStatus,
    ownerId: z.uuid().nullable(),
    ownerName: z.string().nullable(),
    /** Task sinh ra từ dòng này. `null` = chưa biến thành hành động nào. */
    taskId: z.uuid().nullable(),
    taskKey: z.string().nullable(),
    position: z.number().int().nonnegative(),
    createdAt: z.iso.datetime(),
});
/**
 * Biên bản của một sprint. `null` ở `review` = chưa ai mở biên bản.
 *
 * ⚠️ Vỏ object chứ không trả `null` trần: Nest serialize `null` thành body
 * rỗng, `apiFetch` đọc body rỗng thành `undefined`, và React Query từ chối
 * `undefined` ⇒ cả query hỏng — đúng ở trạng thái **thường gặp nhất** của
 * endpoint này.
 */
export const SprintRetroView = z.object({
    sprintId: z.uuid(),
    review: z
        .object({
        goalOutcome: SprintGoalOutcome.nullable(),
        summary: z.string().nullable(),
        updatedAt: z.iso.datetime(),
    })
        .nullable(),
    items: z.array(RetroItemView),
});
export const SaveSprintReviewInput = z.object({
    goalOutcome: SprintGoalOutcome.nullable().optional(),
    summary: z.string().max(20_000).nullable().optional(),
});
export const AddRetroItemInput = z.object({
    kind: RetroItemKind,
    content: z.string().trim().min(1).max(500),
    ownerId: z.uuid().nullable().optional(),
});
export const UpdateRetroItemInput = z.object({
    content: z.string().trim().min(1).max(500).optional(),
    status: RetroItemStatus.optional(),
    ownerId: z.uuid().nullable().optional(),
});
/**
 * Biến một dòng retro thành task ở sprint sau — APM-AGILE-c.
 *
 * ⚠️ Đây là thứ phân biệt một buổi retro với một buổi than phiền có biên bản.
 * Không có đường này thì "lần sau ta sẽ…" nằm lại trong biên bản, và sprint sau
 * đội nêu đúng điều ấy lần nữa.
 */
export const RetroItemToTaskInput = z.object({
    taskTypeId: z.uuid(),
    assigneeId: z.uuid().nullable().optional(),
});
//# sourceMappingURL=sprint-retro.js.map